var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import Icon from "../Icon";
import React, { useRef } from 'react';
import { space, flexbox } from 'styled-system';
import { styled, css, mq } from "../../utils";
var Label = styled.label(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 100%;\n\n  input[type='radio'].radio-button {\n    opacity: 0;\n    position: absolute;\n    margin: 0;\n  }\n\n  svg.check-mark {\n    position: absolute;\n    height: 29px;\n    width: 29px;\n\n    ", ";\n  }\n"], ["\n  width: 100%;\n\n  input[type='radio'].radio-button {\n    opacity: 0;\n    position: absolute;\n    margin: 0;\n  }\n\n  svg.check-mark {\n    position: absolute;\n    height: 29px;\n    width: 29px;\n\n    ", ";\n  }\n"])), mq({
    margin: ['auto', 'unset'],
    bottom: ['0', '-1rem'],
    top: [0, 'unset'],
    right: ['1rem', '0.5rem'],
}));
var ButtonBox = styled.div(function (_a) {
    var fadeOut = _a.fadeOut, checked = _a.checked, colors = _a.theme.colors;
    return css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    position: relative;\n    display: flex;\n    width: 100%;\n    height: 100%;\n    box-sizing: border-box;\n    border: 3px solid ", ";\n    border-radius: 26px;\n    box-shadow: 0 2px 4px 0 rgba(0, 0, 20, 0.34);\n    background-color: ", ";\n    cursor: pointer;\n\n    & > * {\n      ", "\n    }\n\n    &:hover {\n      border-color: ", ";\n    }\n\n    ", ";\n  "], ["\n    position: relative;\n    display: flex;\n    width: 100%;\n    height: 100%;\n    box-sizing: border-box;\n    border: 3px solid ", ";\n    border-radius: 26px;\n    box-shadow: 0 2px 4px 0 rgba(0, 0, 20, 0.34);\n    background-color: ", ";\n    cursor: pointer;\n\n    & > * {\n      ", "\n    }\n\n    &:hover {\n      border-color: ", ";\n    }\n\n    ", ";\n  "])), checked ? colors.primary : 'transparent', colors.white, fadeOut ? 'opacity: 0.5' : '', colors.primary, mq({ borderWidth: ['2px', '3px'] }));
}, space, flexbox);
var FunnelRadioButton = function (_a) {
    var checked = _a.checked, defaultChecked = _a.defaultChecked, value = _a.value, onChange = _a.onChange, fadeOut = _a.fadeOut, children = _a.children, props = __rest(_a, ["checked", "defaultChecked", "value", "onChange", "fadeOut", "children"]);
    var inputRef = useRef(null);
    return (React.createElement(Label, null,
        React.createElement("input", { ref: inputRef, type: "radio", className: "radio-button", value: value, checked: checked, onChange: onChange }),
        React.createElement(ButtonBox, __assign({ checked: checked || defaultChecked, fadeOut: fadeOut, flexDirection: "column" }, props),
            children,
            (checked || defaultChecked) && React.createElement(Icon.GreenCheck, null))));
};
FunnelRadioButton.defaultProps = {
    __type: 'FunnelRadioButton',
    padding: '1rem',
    alignItems: 'center',
    justifyContent: 'center',
};
export default FunnelRadioButton;
var templateObject_1, templateObject_2;
//# sourceMappingURL=FunnelRadioButton.js.map